import angular from 'angular';
import './ng-table';

export default angular.module('app.services.ggTable', [
  'ngTable'
])
.factory('ggTable', function (ngTableParams, $filter) {
  return class ggTable extends ngTableParams {
    constructor(config={}) {
      // https://github.com/esvit/ng-table/wiki/Configuring-your-table-with-ngTableParams
      super(_.merge({
        page: 1,
        count: 10,
        pageSize: 50,
        sorting: config.sorting || {id: 'desc'}
      }, config),{
        debugMode: false,
        total: 0,
        counts: config.counts || [],
        getData: config.getData || (($defer, params) => {
          let orderedData = $filter('orderBy')(this.loadedData || [], params.orderBy());
          orderedData = this.applyFilters(orderedData, params);
          this.enableCalculateTotals && this.calculateTotals(orderedData);
          params.total(orderedData.length);
          this.csv && this.csv.loadTableData(this.cols, orderedData);
          return $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
        })
      });
      this.cols = [];
      this.totals = [];
      this.enableCalculateTotals = config.enableCalculateTotals;
      this.csv = config.csv;
      this.customFilters = config.customFilters || {};
    }

    loadData(data) {
      this.loadedData = data;
      this.loadedDataCount = this.loadedData.length;
      this.reload();
    }

    appendData(data) {
      this.loadedData = (this.loadedData||[]).concat(data);
      this.loadedDataCount = this.loadedData.length;
      this.reload();
    }

    calculateTotals(data) {
      this.totals = _.cloneDeep(this.cols).map((total) => {
        let values = _.map(data, total.field);
        let format = _.isFunction(total.format) ? total.format() : total.format;

        switch(format) {
          case 'number':
          case 'EUR':
          case 'USD':
            total.value = _.sum(values);
            break;
          case 'percentage':
            let nonZeroValues = _.compact(values);
            total.value = _.sum(nonZeroValues) / nonZeroValues.length;
            break;
          case 'n/a':
            total.value = '';
            break;
          default:
            total.value = _.uniq(values).length;
            total.format = 'number';
        }

        if (data.length) {
          if (total.field == 'ctr') {
            let clicks = _.chain(data).map('clicks').sum().value();
            let impressions = _.chain(data).map('impressions').sum().value();
            total.value = _.round(clicks / impressions * 100, 2);
          }
          if (total.field == 'ecpc') {
            let cost = _.chain(data).map('cost').sum().value();
            let clicks = _.chain(data).map('clicks').sum().value();
            total.value = _.round(cost / clicks, 2);
            total.format = _.find(this.cols, {field: 'cost'}).format;
          }
          if (total.field == 'ecpm') {
            let cost = _.chain(data).map('cost').sum().value();
            let impressions = _.chain(data).map('impressions').sum().value();
            total.value = _.round(cost / impressions * 1000, 2);
            total.format = _.find(this.cols, {field: 'cost'}).format;
          }
          if (total.field == 'ecpe') {
            let cost = _.chain(data).map('cost').sum().value();
            let engagedPlayers = _.chain(data).map('engaged_players').sum().value();
            total.value = _.round(cost / engagedPlayers, 2);
            total.format = _.find(this.cols, {field: 'cost'}).format;
          }
          if (total.field == 'ecpi') {
            let cost = _.chain(data).map('cost').sum().value();
            let installs = _.chain(data).map('installs').sum().value();
            total.value = _.round(cost / installs, 2);
            total.format = _.find(this.cols, {field: 'cost'}).format;
          }
          if (total.field == 'ecpa') {
            let cost = _.chain(data).map('cost').sum().value();
            let engagedPlayers = _.chain(data).map('engaged_players').sum().value();
            total.value = _.round(cost / engagedPlayers, 2);
            total.format = _.find(this.cols, {field: 'cost'}).format;
          }
        }

        return total;
      });
    }

    applyFilters(data, params) {
      let filter = angular.copy(params.filter());

      angular.forEach(this.customFilters, (filterFn, field) => {
        data = filterFn(data, filter[field]);
        delete filter[field];
      });

      angular.forEach(filter, function(value, field) {
        if (!!value && `${value}`.trim().match(/^[<=>]/)) {
          data = $filter('filterNumbers')(data, field, value);
          return delete filter[field];
        }
      });

      return $filter('filter')(data, filter);
    }

    remove(loadedObject) {
      this.loadData(_.without(this.loadedData, loadedObject));
    }

    get perPage() {
      return this.count();
    }

    set perPage(count) {
      this.count(count);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./src/services/ggTable.js
 **/